import React from "react";
import { ViewMasterSourcesContainer } from "../../../containers";

const ViewMasterSources = (props) => {
  return <ViewMasterSourcesContainer {...props} />;
};

export default ViewMasterSources;
